var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1092_3755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7885 4.76807L16.5098 11.9999L23.7885 19.2317C23.92 18.9567 23.9999 18.6527 23.9999 18.328V5.67177C23.9999 5.34707 23.92 5.04308 23.7885 4.76807Z",
    fill: "url(#paint0_linear_1092_3755)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.891 3.5625H2.10976C1.78505 3.5625 1.48107 3.64233 1.20605 3.77391L10.509 13.03C11.3316 13.8525 12.6692 13.8525 13.4918 13.03L22.7947 3.77391C22.5197 3.64233 22.2157 3.5625 21.891 3.5625Z",
    fill: "url(#paint1_linear_1092_3755)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.211406 4.76807C0.0798281 5.04308 0 5.34707 0 5.67177V18.328C0 18.6527 0.0798281 18.9568 0.211406 19.2317L7.49011 11.9999L0.211406 4.76807Z",
    fill: "url(#paint2_linear_1092_3755)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.516 12.9944L14.486 14.0244C13.1154 15.3949 10.8853 15.3949 9.5147 14.0244L8.48476 12.9944L1.20605 20.2262C1.48107 20.3578 1.78505 20.4376 2.10976 20.4376H21.891C22.2157 20.4376 22.5197 20.3578 22.7947 20.2262L15.516 12.9944Z",
    fill: "url(#paint3_linear_1092_3755)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1092_3755",
    x1: 16.6143,
    y1: 16.339,
    x2: 23.9999,
    y2: 16.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1092_3755",
    x1: 1.50742,
    y1: 11.63,
    x2: 22.7947,
    y2: 11.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1092_3755",
    x1: 0.104557,
    y1: 16.339,
    x2: 7.49011,
    y2: 16.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1092_3755",
    x1: 1.50742,
    y1: 18.949,
    x2: 22.7947,
    y2: 18.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1092_3755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIc);
export default __webpack_public_path__ + "static/media/mail_ic.f1b694b6efa25e64d99c81f62bd1afc0.svg";
export { ForwardRef as ReactComponent };